import React from 'react'
import bindAll from 'lodash/bindAll'
import Initializers from '../../../dependencies/initializers'
class UserRegisterWizardFormThirdPage extends React.Component {
	constructor(props) {
		super(props)

		bindAll(this, [
			'handleLoginClick'
		])
	}

	handleLoginClick(e) {
		e.preventDefault()

		
			window.location = Initializers.api_host+'/auth/login'
	
	}

	render() {
		return(
			<div className="well-form rounded-sm" id="step3">
        <div className="vertically-message">
          <div className="center">
            <h3 className="heading3 semibold uppercase m-0 m-b-32">Welcome to Astronaut!</h3>
            <div className="heading4 m-b-44">
              Your Astronaut account has been successfully created. Check your email to confirm your account.
            </div>
            <button
            	onClick={this.handleLoginClick}
            	className="btn btn-primary uppercase center">
            	Login
            </button>
            <div className="m-t-32">
              <i>Can't find the email? Check your spam folder.</i>
            </div>
          </div>
        </div>
      </div>
		)
	}
}

export default UserRegisterWizardFormThirdPage
